import React, { useEffect, useState } from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { connect } from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";


// components
import { GenericTableButton } from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";

// labels
import {
    LB_ACTIONS,
    LB_CODE, LB_TITLE,
    LIST, NO_DATA_FOUND
} from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";


// actions


// services
import { slideService } from "../../../jwt/_services/campaign/slideService";
import {ColorFormatter} from "../../../components/tables/colorFormatter";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";


const SlideList = props => {
    const { app } = props.mainProps
    const { domainObject } = props.formProps
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(0);
    const [listItems, setListItems] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const [staticFilter, setStaticFilter] = useState({
        onlyRegistered : true,
        fbDataBase : {  id : null },
        item : {
            campaign : { id : domainObject.id }
        }
    })

    useEffect(()=>{
        setStaticFilter({
            ...staticFilter,
            fbDataBase: { id : props.mainProps?.app?.fbDataBase?.id },
        })

    },[props.mainProps?.app?.fbDataBase?.id])


    useEffect(() => {
        if(!staticFilter.fbDataBase.id)
            return;
        refreshDataList(pageIndex, pageSize, staticFilter);
    }, [pageIndex, pageSize, staticFilter]);

    const handleTableChange = (type, tableChangeParams) => {
        setPageSize(tableChangeParams?.page)
        setPageIndex(tableChangeParams?.sizePerPage)
    };

    const refreshDataList = async (_pageIndex, _pageSize, _filter) => {
        setShowLoading(true)
        const {data} = await slideService.search(_pageIndex, _pageSize, _filter)
        setListItems(data)
        setTotalSize(data?.total)
        setShowLoading(false)
    }

    const confirmDelete = (data) => {
        return ConfirmDelete({ data : data, fbDataBaseId :  app?.fbDataBase?.id, remove : slideService.deleteItem } );
    };

    const editItem = (data) => {
        props.setShowItem(true)
        props.setItemToEdit(data)
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>

    const colorFormatter = (cell) => {
        return (
            <ColorFormatter color={cell}/>
        );
    }

    const columns = [
        {
            dataField: 'id',
            headerStyle: { width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: `UID`,
            headerStyle: {width: '200px'},
        }, {
            dataField: 'code',
            text: `${LB_CODE}`,
            headerStyle: {width: '150px'},
        }, {
            dataField: 'title',
            text: `${LB_TITLE}`
        }, {
            dataField: 'color',
            text: "Color Hex",
            formatter: colorFormatter
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerStyle: {width: '150px'},
            headerAlign: 'center',
            align:'center',
            formatter: actionsFormatter
        }
    ];

    return <>
        { showLoading && showLoader() }
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{LIST}
            </CardTitle>
            <CardBody className="">
                <BootstrapTable
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={listItems || []}
                    columns={columns}
                    noDataIndication={NO_DATA_FOUND}
                    pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                    onTableChange={handleTableChange}
                />
            </CardBody>
        </Card>
    </>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    formProps : state.formProps,
})

const mapActionsToProps = ({})
export default connect(mapStateToProps, mapActionsToProps)(SlideList)